"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTransactionType = exports.DisposalStatus = exports.PaymentFrequency = exports.TitleStatus = exports.LeaseType = exports.BalloonType = exports.AccountType = exports.FinanceType = exports.FlatCancelStatus = exports.TermTypeStatus = exports.TerminationStatus = exports.ReposessionStatus = exports.ProcessStatus = exports.PartyRoleType = exports.BankruptcyStatus = exports.AccountStatus = exports.VciBrand = exports.VciCountry = exports.CustomerAccountRelationship = void 0;
var CustomerAccountRelationship;
(function (CustomerAccountRelationship) {
    CustomerAccountRelationship["Unknown"] = "Unknown";
    CustomerAccountRelationship["Primary"] = "Primary";
    CustomerAccountRelationship["CoBuyer"] = "CoBuyer";
    CustomerAccountRelationship["Guarantor"] = "Guarantor";
})(CustomerAccountRelationship || (exports.CustomerAccountRelationship = CustomerAccountRelationship = {}));
var VciCountry;
(function (VciCountry) {
    VciCountry["USA"] = "USA";
    VciCountry["Canada"] = "Canada";
    VciCountry["Unknown"] = "Unknown";
})(VciCountry || (exports.VciCountry = VciCountry = {}));
var VciBrand;
(function (VciBrand) {
    VciBrand["VW"] = "VW";
    VciBrand["Ducati"] = "Ducati";
    VciBrand["Audi"] = "Audi";
    VciBrand["Bentley"] = "Bentley";
    VciBrand["Other"] = "Other";
    VciBrand["Unknown"] = "Unknown";
})(VciBrand || (exports.VciBrand = VciBrand = {}));
var AccountStatus;
(function (AccountStatus) {
    AccountStatus["Active"] = "Active";
    AccountStatus["PaidOff"] = "PaidOff";
    AccountStatus["Closed"] = "Closed";
    AccountStatus["InProcess"] = "InProcess";
    AccountStatus["Unknown"] = "Unknown";
})(AccountStatus || (exports.AccountStatus = AccountStatus = {}));
var BankruptcyStatus;
(function (BankruptcyStatus) {
    BankruptcyStatus["Bankrupt"] = "Bankrupt";
    BankruptcyStatus["NotBankrupt"] = "NotBankrupt";
    BankruptcyStatus["Unknown"] = "Unknown";
})(BankruptcyStatus || (exports.BankruptcyStatus = BankruptcyStatus = {}));
var PartyRoleType;
(function (PartyRoleType) {
    PartyRoleType["Primary"] = "Primary";
    PartyRoleType["CoBuyer"] = "CoBuyer";
    PartyRoleType["Guarantor"] = "Guarantor";
    PartyRoleType["Unknown"] = "Unknown";
})(PartyRoleType || (exports.PartyRoleType = PartyRoleType = {}));
var ProcessStatus;
(function (ProcessStatus) {
    ProcessStatus["PartiallyChargedOff"] = "PartiallyChargedOff";
    ProcessStatus["FullyChargedOff"] = "FullyChargedOff";
    ProcessStatus["NotChargedOff"] = "NotChargedOff";
    ProcessStatus["Unknown"] = "Unknown";
})(ProcessStatus || (exports.ProcessStatus = ProcessStatus = {}));
var ReposessionStatus;
(function (ReposessionStatus) {
    ReposessionStatus["Redeemed"] = "Redeemed";
    ReposessionStatus["Repossessed"] = "Repossessed";
    ReposessionStatus["NotRepossessed"] = "NotRepossessed";
    ReposessionStatus["Unknown"] = "Unknown";
})(ReposessionStatus || (exports.ReposessionStatus = ReposessionStatus = {}));
var TerminationStatus;
(function (TerminationStatus) {
    TerminationStatus["Setup"] = "Setup";
    TerminationStatus["Terminated"] = "Terminated";
    TerminationStatus["NotTerminated"] = "NotTerminated";
    TerminationStatus["Unknown"] = "Unknown";
})(TerminationStatus || (exports.TerminationStatus = TerminationStatus = {}));
var TermTypeStatus;
(function (TermTypeStatus) {
    TermTypeStatus["Normal"] = "Normal";
    TermTypeStatus["EarlyTermByAuction"] = "EarlyTermByAuction";
    TermTypeStatus["EarlyTermByAppraisal"] = "EarlyTermByAppraisal";
    TermTypeStatus["EarlyTermByBook"] = "EarlyTermByBook";
    TermTypeStatus["CommercialLease"] = "CommercialLease";
    TermTypeStatus["TerminationByPayoff"] = "TerminationByPayoff";
    TermTypeStatus["TerminatedViaThirdPartySale"] = "TerminatedViaThirdPartySale";
    TermTypeStatus["NotTerminated"] = "NotTerminated";
    TermTypeStatus["Unknown"] = "Unknown";
})(TermTypeStatus || (exports.TermTypeStatus = TermTypeStatus = {}));
var FlatCancelStatus;
(function (FlatCancelStatus) {
    FlatCancelStatus["NotFlatCancelled"] = "NotFlatCancelled";
    FlatCancelStatus["FlatCancelled"] = "FlatCancelled";
    FlatCancelStatus["Unknown"] = "Unknown";
})(FlatCancelStatus || (exports.FlatCancelStatus = FlatCancelStatus = {}));
var FinanceType;
(function (FinanceType) {
    FinanceType["Lease"] = "Lease";
    FinanceType["Retail"] = "Retail";
    FinanceType["Unknown"] = "Unknown";
})(FinanceType || (exports.FinanceType = FinanceType = {}));
var AccountType;
(function (AccountType) {
    AccountType["Balloon"] = "Balloon";
    AccountType["Buyback"] = "Buyback";
    AccountType["CompanyCar"] = "CompanyCar";
    AccountType["DailyRental"] = "DailyRental";
    AccountType["Lease"] = "Lease";
    AccountType["Loan"] = "Loan";
    AccountType["MysteryShopper"] = "MysteryShopper";
    AccountType["ServiceLoaner"] = "ServiceLoaner";
    AccountType["SilverCar"] = "SilverCar";
    AccountType["SoldOutOfTrust"] = "SoldOutOfTrust";
    AccountType["Unknown"] = "Unknown";
    AccountType["PremierPurchase"] = "Premier Purchase";
    AccountType["vwSelect"] = "VW Select";
    AccountType["AudiSelect"] = "Audi Select";
})(AccountType || (exports.AccountType = AccountType = {}));
var BalloonType;
(function (BalloonType) {
    BalloonType["Balloon"] = "Balloon";
    BalloonType["COP"] = "COP";
    BalloonType["NotABalloon"] = "NotABalloon";
    BalloonType["Unknown"] = "Unknown";
})(BalloonType || (exports.BalloonType = BalloonType = {}));
var LeaseType;
(function (LeaseType) {
    LeaseType["Lease"] = "Lease";
    LeaseType["NotALease"] = "NotALease";
    LeaseType["SinglePay"] = "SinglePay";
    LeaseType["Unknown"] = "Unknown";
})(LeaseType || (exports.LeaseType = LeaseType = {}));
var TitleStatus;
(function (TitleStatus) {
    TitleStatus["AcquisitionSalvageRebuild"] = "AcquisitionSalvageRebuild";
    TitleStatus["DuplicateTitleOrdered"] = "DuplicateTitleOrdered";
    TitleStatus["ElectronicLienReleaseProcessed"] = "ElectronicLienReleaseProcessed";
    TitleStatus["ElectronicLienReleaseToThirdPartyProcessed"] = "ElectronicLienReleaseToThirdPartyProcessed";
    TitleStatus["ElectronicTitleReceived"] = "ElectronicTitleReceived";
    TitleStatus["FinalContractMadeToRegionAndDealer"] = "FinalContractMadeToRegionAndDealer";
    TitleStatus["LienNoticeAboutNoTitle"] = "LienNoticeAboutNoTitle";
    TitleStatus["LienReleaseProcessed"] = "LienReleaseProcessed";
    TitleStatus["NameChange"] = "NameChange";
    TitleStatus["NoTitle"] = "NoTitle";
    TitleStatus["NotReceived"] = "NotReceived";
    TitleStatus["PaidInFullAndCustomerReceivedTitle"] = "PaidInFullAndCustomerReceivedTitle";
    TitleStatus["PaidInFullOtherRecievedTitle"] = "PaidInFullOtherRecievedTitle";
    TitleStatus["PayoffRequested"] = "PayoffRequested";
    TitleStatus["PayoffTitleRequestRejected"] = "PayoffTitleRequestRejected";
    TitleStatus["PendingTitleWorkedWaitingOnInfo"] = "PendingTitleWorkedWaitingOnInfo";
    TitleStatus["PhysicalTitleRequested"] = "PhysicalTitleRequested";
    TitleStatus["ProcessedLeaseToLoan"] = "ProcessedLeaseToLoan";
    TitleStatus["Received"] = "Received";
    TitleStatus["RepoStatusAndTitleFollowupRequired"] = "RepoStatusAndTitleFollowupRequired";
    TitleStatus["SeeVendorSiteForDetails"] = "SeeVendorSiteForDetails";
    TitleStatus["SentForCorrection"] = "SentForCorrection";
    TitleStatus["SentForStateToStateTransfer"] = "SentForStateToStateTransfer";
    TitleStatus["SentToAuction"] = "SentToAuction";
    TitleStatus["SentToDealer"] = "SentToDealer";
    TitleStatus["SubstitutionOfCollateral"] = "SubstitutionOfCollateral";
    TitleStatus["TitleFollowupExhausted"] = "TitleFollowupExhausted";
    TitleStatus["TitleIsDiscrepant"] = "TitleIsDiscrepant";
    TitleStatus["TitleSentToPar"] = "TitleSentToPar";
    TitleStatus["TitleSentToVwAuburnHills"] = "TitleSentToVwAuburnHills";
    TitleStatus["TitleSentToVwLibertyville"] = "TitleSentToVwLibertyville";
    TitleStatus["TransferToEquity"] = "TransferToEquity";
    TitleStatus["VendorProcessedPhysicalTitleRequest"] = "VendorProcessedPhysicalTitleRequest";
    TitleStatus["Unknown"] = "Unknown";
})(TitleStatus || (exports.TitleStatus = TitleStatus = {}));
var PaymentFrequency;
(function (PaymentFrequency) {
    PaymentFrequency["Weekly"] = "Weekly";
    PaymentFrequency["Biweekly"] = "Biweekly";
    PaymentFrequency["SemiMonthly"] = "Semi-Monthly";
    PaymentFrequency["Monthly"] = "Monthly";
    PaymentFrequency["Unknown"] = "Unknown";
})(PaymentFrequency || (exports.PaymentFrequency = PaymentFrequency = {}));
var DisposalStatus;
(function (DisposalStatus) {
    DisposalStatus["DisposedCurrentMonth"] = "DisposedCurrentMonth";
    DisposalStatus["DisposedPriorMonth"] = "DisposedPriorMonth";
    DisposalStatus["NotDisposed"] = "NotDisposed";
    DisposalStatus["Unwind"] = "Unwind";
    DisposalStatus["Unknown"] = "Unknown";
})(DisposalStatus || (exports.DisposalStatus = DisposalStatus = {}));
var PaymentTransactionType;
(function (PaymentTransactionType) {
    PaymentTransactionType["NotFound"] = "NotFound";
    PaymentTransactionType["None"] = "None";
    PaymentTransactionType["RecoveryAACAPayment"] = "RecoveryAACAPayment";
    PaymentTransactionType["RecoveryAgencyARTPayment"] = "RecoveryAgencyARTPayment";
    PaymentTransactionType["RecoveryAgencyAFNIPayment"] = "RecoveryAgencyAFNIPayment";
    PaymentTransactionType["AudiCarePayment"] = "AudiCarePayment";
    PaymentTransactionType["CanadianCreditCardPayment"] = "CanadianCreditCardPayment";
    PaymentTransactionType["CreditCardPayment"] = "CreditCardPayment";
    PaymentTransactionType["ChryslerBuybackPayment"] = "ChryslerBuybackPayment";
    PaymentTransactionType["CanadianInternetPayment"] = "CanadianInternetPayment";
    PaymentTransactionType["CollectionFeePayment"] = "CollectionFeePayment";
    PaymentTransactionType["CanadianOneTimePayment"] = "CanadianOneTimePayment";
    PaymentTransactionType["DepositoryFinancialInstitutionPayment"] = "DepositoryFinancialInstitutionPayment";
    PaymentTransactionType["DirectFinanceDownPayment"] = "DirectFinanceDownPayment";
    PaymentTransactionType["DirectFinancePayoffPayment"] = "DirectFinancePayoffPayment";
    PaymentTransactionType["DealerServiceLoanerPayment"] = "DealerServiceLoanerPayment";
    PaymentTransactionType["OnetimePayoffPayment"] = "OnetimePayoffPayment";
    PaymentTransactionType["FeeAssessmentPayment"] = "FeeAssessmentPayment";
    PaymentTransactionType["DealerServiceLoanerPayoffPayment"] = "DealerServiceLoanerPayoffPayment";
    PaymentTransactionType["HSBCPaymentLockboxPayment"] = "HSBCPaymentLockboxPayment";
    PaymentTransactionType["HSBCPaymentLockboxRemarketingPayment"] = "HSBCPaymentLockboxRemarketingPayment";
    PaymentTransactionType["HSBCHouseRetailPayment"] = "HSBCHouseRetailPayment";
    PaymentTransactionType["InsuranceProceedsLeasePayment"] = "InsuranceProceedsLeasePayment";
    PaymentTransactionType["InsuranceProceedsRetailPayment"] = "InsuranceProceedsRetailPayment";
    PaymentTransactionType["InsuranceProceedsPayment"] = "InsuranceProceedsPayment";
    PaymentTransactionType["InHouseDepositPayment"] = "InHouseDepositPayment";
    PaymentTransactionType["RecurringACHPayment"] = "RecurringACHPayment";
    PaymentTransactionType["AuctionProceedsPayment"] = "AuctionProceedsPayment";
    PaymentTransactionType["LegalFeePayment"] = "LegalFeePayment";
    PaymentTransactionType["HSBCLKEPayment"] = "HSBCLKEPayment";
    PaymentTransactionType["ManufacturerPayment"] = "ManufacturerPayment";
    PaymentTransactionType["MoneyGramPayment"] = "MoneyGramPayment";
    PaymentTransactionType["RecoveryAgencyMRSPayment"] = "RecoveryAgencyMRSPayment";
    PaymentTransactionType["NBSBankruptcyPayment"] = "NBSBankruptcyPayment";
    PaymentTransactionType["OnetimePayment"] = "OnetimePayment";
    PaymentTransactionType["PTMSTaxPayment"] = "PTMSTaxPayment";
    PaymentTransactionType["RecoveryPayment"] = "RecoveryPayment";
    PaymentTransactionType["RepossessionFeePayment"] = "RepossessionFeePayment";
    PaymentTransactionType["TitleRegistrationAssessmentsPayment"] = "TitleRegistrationAssessmentsPayment";
    PaymentTransactionType["LeaseTransferFeesAssessmentsPayment"] = "LeaseTransferFeesAssessmentsPayment";
    PaymentTransactionType["ParkingTicketAssessmentsPayment"] = "ParkingTicketAssessmentsPayment";
    PaymentTransactionType["RecoveryAgencyVITALPayment"] = "RecoveryAgencyVITALPayment";
    PaymentTransactionType["LemonLawBrandGoodwillPayment"] = "LemonLawBrandGoodwillPayment";
    PaymentTransactionType["WireTransferPayment"] = "WireTransferPayment";
    PaymentTransactionType["WinstonAndWinstonPayment"] = "WinstonAndWinstonPayment";
    PaymentTransactionType["WesternUnionLockboxPayment"] = "WesternUnionLockboxPayment";
    PaymentTransactionType["RecoveryAgencyWWRPayment"] = "RecoveryAgencyWWRPayment";
    PaymentTransactionType["WarrantyCancelsWithDealerReservePayment"] = "WarrantyCancelsWithDealerReservePayment";
    PaymentTransactionType["BrandPayments"] = "BrandPayments";
})(PaymentTransactionType || (exports.PaymentTransactionType = PaymentTransactionType = {}));
//# sourceMappingURL=enums.js.map